import notification from '@/utils/notification'
import HTTP from '@/utils/http'
import { EmailTypes } from '@/utils/consts'
import projectNotification from './project'
import tenderNotification from './tender'
import tenancyNotification from './tenancy'
import hotbNotification from './hotb'
import tenantProjectsNotification from './tenantProject'
import workPermits from './workPermits'
import directories from './directories'

export const emailWriters = {
  [EmailTypes.tenders.invitation]: async (extMetaData) => { const emails = await tenderNotification.writeIssueNoticeEmail(false); return emails },
  [EmailTypes.tenders.addendum]: async () => { const emails = await tenderNotification.writeIssueNoticeEmail(true); return emails },
  [EmailTypes.tenders.extendNotifyVendor]: async (extMetaData) => { const emails = await tenderNotification.writeExtendNotifyVendorEmail(extMetaData.tender); return emails },
  [EmailTypes.tenders.extendNotifyEngineer]: async (extMetaData) => { const emails = await tenderNotification.writeExtendNotifyEngineerEmail(extMetaData.tender); return emails },
  [EmailTypes.tenders.approvalResult]: async (extMetaData) => {
    const emails = await tenderNotification.writeApprovalResultEmail(EmailTypes.tenders.approvalResult, extMetaData); return emails
  },
  [EmailTypes.tenders.awardVendor]: async (extMetaData) => {
    const emails = await tenderNotification.writeAwardResultEmail(extMetaData); return emails
  },
  [EmailTypes.tenders.regretVendor]: tenderNotification.writeAwardResultEmail,
  [EmailTypes.tenders.submitBid]: (extMetaData) => {
    const emails = tenderNotification.writeSubmitBidEmail(EmailTypes.tenders.submitBid, extMetaData)
    return emails
  },
  [EmailTypes.tenders.withdrawBid]: tenderNotification.writeWithdrawBidEmail,
  [EmailTypes.tenders.submitForApproval]: tenderNotification.writeSubmitForApprovalEmail,
  [EmailTypes.tenders.query]: tenderNotification.writeQueryEmail,
  [EmailTypes.tenders.submitQuery]: tenderNotification.writeSubmitQueryEmail,
  [EmailTypes.tenders.queryResponse]: tenderNotification.writeQueryResponseEmail,

  // ---- projects ----
  [EmailTypes.projects.invitation]: async () => {
    const emails = await projectNotification.notifyInvitation(EmailTypes.projects.invitation)
    return emails
  },
  [EmailTypes.projects.submissionAcceptance]: async (extMetaData) => {
    const emails = await projectNotification.notifySubmissionAcceptance(EmailTypes.projects.submissionAcceptance, extMetaData)
    return emails
  },
  [EmailTypes.projects.submissionSubmitted]: async (extMetaData) => {
    const emails = await projectNotification.notifyCompletionSubmission(EmailTypes.projects.submissionSubmitted, extMetaData)
    return emails
  },
  [EmailTypes.projects.invitePrimaryContact]: async (extMetaData) => {
    const emails = await projectNotification.invitePrimaryContact(extMetaData)
    return emails
  },
  // ---- tenancies ----
  [EmailTypes.tenancies.create]: async (extMetaData) => {
    const emails = await tenancyNotification.writeCreateEmail(extMetaData)
    return emails
  },
  [EmailTypes.tenancies.requestForInvitation]: async (extMetaData) => {
    const email = await tenancyNotification.requestForInvitation(extMetaData)
    return email
  },
  [EmailTypes.tenancies.inviteTenantMasterUser]: async (extMetaData) => {
    const email = await tenancyNotification.inviteTenantMasterUser(extMetaData)
    return email
  },
  [EmailTypes.tenancies.inviteSubAccount]: async (extMetaData) => {
    const email = await tenancyNotification.inviteSubAccount(extMetaData)
    return email
  },
  [EmailTypes.tenancies.inviteContractor]: async (extMetaData) => {
    const email = await tenancyNotification.inviteContractor(extMetaData)
    return email
  },
  // ---- handovers ----
  [EmailTypes.handovers.submitForApproval]: hotbNotification.writeSubmitForApprovalEmail,
  [EmailTypes.handovers.arrange]: async (extMetaData) => {
    const email = await hotbNotification.writeArrangeEmail(extMetaData)
    return email
  },
  [EmailTypes.handovers.unsigned]: async (extMetaData) => {
    const email = await hotbNotification.writeNotifyUnsignedEmail(extMetaData)
    return email
  },
  [EmailTypes.handovers.complete]: async (extMetaData) => {
    const email = await hotbNotification.writeCompleteEmail(extMetaData)
    return email
  },
  [EmailTypes.handovers.requestChange]: async (extMetaData) => {
    const email = await hotbNotification.writeRequestChangeEmail(extMetaData)
    return email
  },
  [EmailTypes.handovers.resetToDraft]: async (extMetaData) => {
    const email = await hotbNotification.writeResetToDraftEmail(extMetaData)
    return email
  },
  [EmailTypes.takebacks.submitForApproval]: hotbNotification.writeSubmitForApprovalEmail,
  [EmailTypes.takebacks.arrange]: async (extMetaData) => {
    const email = await hotbNotification.writeArrangeEmail(extMetaData)
    return email
  },
  [EmailTypes.takebacks.unsigned]: async (extMetaData) => {
    const email = await hotbNotification.writeNotifyUnsignedEmail(extMetaData)
    return email
  },
  [EmailTypes.takebacks.complete]: async (extMetaData) => {
    const email = await hotbNotification.writeCompleteEmail(extMetaData)
    return email
  },
  [EmailTypes.takebacks.requestChange]: async (extMetaData) => {
    const email = await hotbNotification.writeRequestChangeEmail(extMetaData)
    return email
  },
  [EmailTypes.takebacks.resetToDraft]: async (extMetaData) => {
    const email = await hotbNotification.writeResetToDraftEmail(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.submitProject]: async (extMetaData) => {
    const email = await tenantProjectsNotification.submitProject(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.submitDesignDocs]: async (extMetaData) => {
    const email = await tenantProjectsNotification.submitDesignDocs(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.completeSubmission]: async (extMetaData) => {
    const email = await tenantProjectsNotification.completeSubmission(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.completePostfitout]: async (extMetaData) => {
    const email = await tenantProjectsNotification.completePostfitout(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.completeGreenFitOut]: tenantProjectsNotification.completeGreenFitOut,
  [EmailTypes.tenantProjects.nextReviewer]: async (extMetaData) => {
    const email = await tenantProjectsNotification.nextReviewer(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.reassign]: async (extMetaData) => {
    const email = await tenantProjectsNotification.reassign(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.inspectionFollowUp]: async (extMetaData) => {
    const email = await tenantProjectsNotification.inspectionFollowUp(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.withdrawTenantProject]: async (extMetaData) => {
    const email = await tenantProjectsNotification.withdrawTenantProject(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.batchStatusChanged]: async (extMetaData) => {
    const email = await tenantProjectsNotification.batchStatusChanged(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.invitePrimaryContact]: async (extMetaData) => {
    const email = await tenantProjectsNotification.invitePrimaryContact(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.depositNotifyPM]: async (extMetaData) => {
    const email = await tenantProjectsNotification.depositNotifyPM(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.depositNotifyAccounting]: async (extMetaData) => {
    const email = await tenantProjectsNotification.depositNotifyAccounting(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.refundNotifyPM]: async (extMetaData) => {
    const email = await tenantProjectsNotification.refundNotifyPM(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.managementFeeNotifyPM]: async (extMetaData) => {
    const email = await tenantProjectsNotification.managementFeeNotifyPM(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.managementFeeNotifyAccounting]: async (extMetaData) => {
    const email = await tenantProjectsNotification.managementFeeNotifyAccounting(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.refundNotifyPM]: async (extMetaData) => {
    const email = await tenantProjectsNotification.refundNotifyPM(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.refundNotifyAccounting]: async (extMetaData) => {
    const email = await tenantProjectsNotification.refundNotifyAccounting(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.requestRefund]: async (extMetaData) => {
    const email = await tenantProjectsNotification.requestRefund(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.completeFinalDocuments]: async (extMetaData) => {
    const email = await tenantProjectsNotification.completeFinalDocuments(extMetaData)
    return email
  },
  [EmailTypes.tenantProjects.exemptFinalDocuments]: async (extMetaData) => {
    const email = await tenantProjectsNotification.exemptFinalDocuments(extMetaData)
    return email
  },
  // ----- work permits -----
  [EmailTypes.workPermits.rejected]: workPermits.rejected,
  [EmailTypes.workPermits.suspendPP]: workPermits.suspendPP,
  [EmailTypes.workPermits.suspendWP]: workPermits.suspendWP,
  [EmailTypes.workPermits.resumedPP]: workPermits.resumedPP,
  [EmailTypes.workPermits.resumedWP]: workPermits.resumedWP,

  // For project permit
  [EmailTypes.workPermits.firstApplyWP]: workPermits.firstApplyWP,
  [EmailTypes.workPermits.nextReviewerPP]: workPermits.nextReviewer,
  [EmailTypes.workPermits.approveNotificationPP]: workPermits.approveNotificationPP,
  [EmailTypes.workPermits.nextApprover]: workPermits.nextReviewer,
  // For Normal work permit
  [EmailTypes.workPermits.applyWP]: workPermits.firstApplyWP,
  [EmailTypes.workPermits.nextReviewerWP]: workPermits.nextReviewer,
  [EmailTypes.workPermits.nextSecondReviewerWP]: workPermits.nextReviewer,
  [EmailTypes.workPermits.nextApproverWP]: workPermits.nextReviewer,
  [EmailTypes.workPermits.approveNotificationWP]: workPermits.approveNotificationWP,

  // For Normal Hoisting permit
  [EmailTypes.workPermits.applyHoisting]: workPermits.applyHoisting,
  [EmailTypes.workPermits.applyHoistingAfterOfficeHour]: workPermits.applyHoistingAfterOfficeHour,
  [EmailTypes.workPermits.applyHoistingToContractor]: workPermits.applyHoistingToContractor,
  [EmailTypes.workPermits.hoistingWAPPR]: workPermits.hoistingWAPPR,
  [EmailTypes.workPermits.hoistingAfterOfficeHourWAPPR]: workPermits.hoistingAfterOfficeHourWAPPR,
  [EmailTypes.workPermits.hoistingNextReviewer]: workPermits.hoistingNextReviewer,
  [EmailTypes.workPermits.approveNotificationHP]: workPermits.approveNotificationHP,

  [EmailTypes.workPermits.applyWpToContractor]: workPermits.applyWpToContractor,

  // For permit extension
  [EmailTypes.workPermits.applyExtendWPToContractor]: workPermits.applyExtendWPToContractor,
  [EmailTypes.workPermits.applyExtendWPToHkLandUser]: workPermits.applyExtendWPToHkLandUser,
  [EmailTypes.workPermits.approveExtendWP]: workPermits.approveExtendWP,
  [EmailTypes.workPermits.rejectExtensionWP]: workPermits.rejectExtensionWP,

  [EmailTypes.directories.waitForApproval]: directories.waitForApproval,
  [EmailTypes.directories.waitForProcessing]: directories.waitForProcessing,
  [EmailTypes.directories.approved]: directories.approved,
  [EmailTypes.directories.rejected]: directories.rejected,
  [EmailTypes.directories.submitted]: directories.submitted,

  [EmailTypes.jobs.contactInfoConfirm]: async (extMetaData) => {
    const email = await tenancyNotification.contactInfoConfirm(extMetaData)
    return email
  },
}

export async function buildEmails (emailType, extMetaData) {
  return emailWriters[emailType](extMetaData, emailType)
}

/**
 *
 * @param {keyof emailWriters} emailType
 * @param {object} extMetaData
 * @returns
 */
export async function sendEmail (emailType, extMetaData, notify = true, silentSend = false) {
  const emails = await buildEmails(emailType, extMetaData)
  const results = await Promise.all(emails.map(async (email) => {
    try {
      if (silentSend) {
        await HTTP.silentPost('/sendmail', email.mailRequest)
      } else {
        await HTTP.post('/sendmail', email.mailRequest)
      }

      return { isSuccess: true, to: email.mailRequest.to }
    } catch (err) {
      console.error(err)
      if (notify) {
        notification.handleResponseError(err, email.notificationPrefix)
      }
      return { isSuccess: false, to: email.mailRequest.to }
    }
  }))
  return results
}

export async function sendEmailByType (template, extMetaData, notifyMeta, silentSend = false) {
  const result = { isSuccess: true, to: notifyMeta && notifyMeta.to }
  let alertResponse = null

  try {
    if (silentSend) {
      alertResponse = await HTTP.silentPost('/sendmail/bytype', { ...extMetaData, template })
    } else {
      alertResponse = await HTTP.post('/sendmail/bytype', { ...extMetaData, template })
    }
  } catch (err) {
    alertResponse = err.response
    result.isSuccess = false
  } finally {
    if (notifyMeta && notifyMeta.notify) {
      notification.handleResponseAlert(alertResponse, notifyMeta.notificationPrefix)
    }
  }

  return result
}
